import { render, staticRenderFns } from "./SuccessfullyUpdated.vue?vue&type=template&id=352b66e0&"
import script from "./SuccessfullyUpdated.vue?vue&type=script&lang=js&"
export * from "./SuccessfullyUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports